exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-20c46274]{color:#000;width:-moz-fit-content;width:fit-content}", ""]);

// exports
